<div>
	@if (rotor) {
		<div class="row">
			<label class="col-md-2 col-form-label-sm">Operation:</label>
			@if (!multiOps) {
				<div class="col-md-6">
					@if (operations !== undefined) {
						<select class="form-control form-control-sm op-list" [(ngModel)]="operation" (ngModelChange)="refreshRegimeCounts()"
							[title]="operations | operationslimitnote : 'vibe' : rotor.rotorid">
							@for (operation of operations; track operation) {
								<option [ngValue]="operation" [class]="GetOpClass(operation, true)">
									{{operation | operationlabel : (fleet ? fleet.time_offset_hours : 0) : true : false : true}}
								</option>
							}
						</select>
					}
					@if (operations === undefined) {
						<select class="form-control form-control-sm" disabled>
							<option>Loading RTB operations...</option>
						</select>
					}
				</div>
			}
			@if (multiOps) {
				<div class="col-md-6">
					@if (operations !== undefined) {
						<select class="form-control form-control-sm" [(ngModel)]="multiOperation" (ngModelChange)="refreshRegimeCounts()"
							[title]="operations | operationslimitnote : 'vibe' : rotor.rotorid" multiple>
							@for (operation of operations; track operation) {
								<option [ngValue]="operation">
									{{operation.start_time | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}
								</option>
							}
						</select>
					}
					@if (operations === undefined) {
						<select class="form-control form-control-sm" disabled multiple>
							<option>Loading RTB operations...</option>
						</select>
					}
				</div>
			}
			<div class="col-md-4">
				<label class="col-form-label-sm">
					<input [(ngModel)]="multiOps" type="checkbox" (ngModelChange)="refreshRegimeCounts()">
					Multiple operations
				</label>
				@if (multiOps) {
					<p>Ctrl+click to select multiple operations, 5 maximum</p>
				}
			</div>
		</div>
	}

	@if (regimeCounts !== undefined && regimeCounts.length === 0) {
		<div class="loading-status">
			No balance data is available for the selected operation
		</div>
	}

	@if (operations && operations.length === 0) {
		<div class="loading-status">
			No operations with vibe data are available
		</div>
	}

	@if (operations && operations.length > 0 && regimeCounts === undefined) {
		<div class="loading-status">
			<div class="logo-spin"></div>
			Loading operation data...
		</div>
	}

	@if (regimeCounts !== undefined && regimeCounts.length > 0) {
		<div class="row">
			<div class="col-lg-4">
				<app-regime-list [regimes]="regimeCounts" (evaluateChange)="regimesChange()"></app-regime-list>
				@if (rotor.balancedata && rotor.balancedata.numblades >= 4 && !rotor.balancedata.oneperrev) {
					<app-shaft-order [(shaftOrder)]="shaftOrder" [showOneRev]="true" [(oneRevOnly)]="onePerRevOnly" (refresh)="updatePlot()"></app-shaft-order>
				}
				@if (selectedRegimes && selectedRegimes.length && isH60) {
					<div class="panel mt-3">
						<div class="heading">Current Adjustments</div>
						<div class="content">
							<p>Valid H60 adjustments are 0, L, H, LL, LH, HH</p>
							<form #crtAdjForm="ngForm">
								<table class="adjustments">
									<tr>
										<th></th>
										@for (blade of rotor.blade; track blade) {
											<th>{{blade.name}}</th>
										}
									</tr>
									<tr>
										<th>
											<span>{{ rotor.adjdef[0] | adjdeflabel }}:</span>
										</th>
										@for (blade of rotor.blade; track blade; let j = $index) {
											<td>
												<input [(ngModel)]="crtAdj[j]" (keyup.enter)="updatePlot()" type="text" [name]="'crtAdj' + blade.name" class="adj-entry"
													pattern="(?:0|[lL][lLhH]?|[hH]{1,2})">
											</td>
										}
									</tr>
									<tr class="divider">
										<th></th>
									</tr>
								</table>
							</form>
						</div>
					</div>
				}
				@if (selectedRegimes && selectedRegimes.length) {
					<div class="panel mt-3">
						<div class="heading">{{ isH60 ? 'New ' : '' }}Adjustments</div>
						@if (adjustments === null) {
							<div class="content">
								No adjustments available
							</div>
						}
						@else {
							<div class="content">
								<form #adjustmentForm="ngForm">
									<app-adjustment-grid [rotor]="rotor" [adjustments]="adjustments" [mode]="isH60 ? 'h60' : 'number'" [alternates]="alternates" [adjDetail]="adjDetail"
										[adjustmentSelect]="adjustmentSelect" (enter)="ManualAdjustment()" (selectChange)="updatePlot()"
										(alternateSelect)="SetAdjustment($event.row, $event.alt)"></app-adjustment-grid>
								</form>
								<button [disabled]="this.api.user.role === 'readonly'" (click)="RecordAdjustment()" class="button block">Record adjustment</button>
							</div>
						}
					</div>
				}
			</div>
			@if (errormessage) {
				<div class="col-lg-8 mt-3">
					<app-dvs-chart [error]="errormessage" [height]="'600px'"></app-dvs-chart>
				</div>
			}
			@if (vshafts && vshafts.length && !errormessage) {
				<div class="col-lg-8 mt-3">
					<div class="bubble-tabs mt-0">
						@for (vshaft of vshafts; track vshaft) {
							<a class="bubble-tab" [routerLink]="[vshaft.id]" routerLinkActive="selected">{{ vshaft.name }}</a>
						}
					</div>
					<router-outlet (activate)="updateRouterOutlet($event)"></router-outlet>
					@if (trackOptions) {
						<div class="panel">
							<div class="heading">Blade track</div>
							<div class="content">
								<app-dvs-chart [options]="trackOptions" [height]="'400px'"></app-dvs-chart>
								@if (trackOptions) {
									<div class="chart-legend">
										<span class="legend-item">
											<span class="swatch square"></span> Averages
										</span>
										<span class="legend-item">
											<span class="swatch diamond"></span> Predictions
										</span>
									</div>
								}
							</div>
						</div>
					}
				</div>
			}
		</div>
	}
</div>
